import { StatusTag } from '@prometheus/components';
import { DateCell } from '@prometheus/features';
import { getSubmissionStatusInfo } from '@prometheus/utils';
import i18n from 'i18next';

export const columns = () => [
  {
    Header: i18n.t('tables.cols.id'),
    accessor: 'shortcut',
    width: '3%',
    maxWidth: 100,
  },
  { Header: i18n.t('tables.cols.author'), accessor: 'created.user.name' },
  {
    Header: i18n.t('tables.cols.updated'),
    accessor: 'modified.timestamp',
    Cell: DateCell,
  },
  {
    Header: i18n.t('tables.cols.status'),
    accessor: 'status',
    id: 'status',
    minWidth: 100,
    width: '5%',
    Cell: ({ value }) => {
      const status = getSubmissionStatusInfo(value);
      return status ? (
        <StatusTag
          text={status.name}
          color={status.color}
          align="center"
          light
        />
      ) : (
        <></>
      );
    },
  },
];
